var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LHotline',{attrs:{"latLngs":_vm.latLngArray,"min":0,"max":1,"palette":{
    0.2: '#F44336',
    0.3: '#9C27B0',
    0.4: '#0D47A1',
    0.9: '#2196F3',
  },"outline-color":"white","weight":5,"outline-width":1,"interactive":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }